import Logout from '@mui/icons-material/Logout'
import { CircularProgress, Dropdown } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { viewerModel } from '~/entities/common/viewer'
import { UserIcon } from '~/shared/ui/Icons'
import { MenuButton, Menu, MenuItem } from './styled'

export function AccountMenu() {
  const { t } = useTranslation()
  return (
    <Dropdown>
      <MenuButton
        loadingIndicator={<CircularProgress />}
        data-testid='home-header-account-button'
      >
        <UserIcon />
      </MenuButton>
      <Menu>
        <MenuItem component={Link} to='/user-personal-data'>
          {t('personal data')}
        </MenuItem>
        <MenuItem onClick={() => viewerModel.signOut()}>
          <Logout />
          {t('button.logout')}
        </MenuItem>
      </Menu>
    </Dropdown>
  )
}
